module.exports = __webpack_public_path__ + "img/ctrl-pauli-y-stub-mid-+i.dfcaa9de.svg";